<template lang="pug">
.container.mx-auto(class="xl:w-80")
   draggable.flex.flex-wrap(v-model="pages" :options="{draggable:'.item'}" @start="drag=true" @end="drag=false; reorder(pages)")
      site-box.item(v-for="page in orderedPages" :key="page._id" :page="page")
      new-box(slot="footer" :amount="pages.length" :showModal="showModal")
   modal(:show="modal")
</template>

<script>
import axios from 'axios'
import draggable from 'vuedraggable'
import SiteBox from '@/components/modules/SiteBox'
import Modal from '@/components/modules/Modal'
import NewBox from '@/components/modules/NewBox'
import { EventBus } from '@/components/eventBus'
import {_} from 'vue-underscore'

export default {
  name: 'MainView',
  components: {
    SiteBox,
    Modal,
    NewBox,
    draggable
  },
  created () {
    this.fetchPages()
    EventBus.$on('fetchPages', clickCount => {
      this.fetchPages()
    })
  },
  methods: {
    fetchPages () {
      axios.get(`page`).then(res => {
        if (res.status === 200) {
          this.pages = res.data
        }
      })
    },
    reorder (pages) {
      pages.forEach((page, int) => {
        page.settings.order = int
        axios.put(`page/` + page._id, page).then(res => {
          console.log(res)
        })
      })
    },
    showModal () {
      console.log('doing it')
      this.modal = true
      console.log(this.modal)
    }
  },
  computed: {
    orderedPages: function () {
      return _.sortBy(this.pages, o => { if (o.settings) { return o.settings.order } })
    }
  },
  data () {
    return {
      pages: [],
      modal: false
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard.vue